export default "__VITE_ASSET__CC$3S2nn__"